<template v-if="!getUserData.certificate">
    <div class="width-full">

        <v-container fluid grid-list-xl class="general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar></header-bar>
                </v-flex>
            </v-layout>

            <div class="scrolling-content-useraccount padding-left-xxl padding-right-xxl">
                <v-layout row wrap class="user-account-page-content page-content">
                    <v-flex xl10 md8 sm6 xs12 align-start>
                        <h2 class="page-title">{{text("db.global.TYPE_GTS_MYDATA_TITLE_A")}}</h2>
                    </v-flex>

                    <v-flex lg9 xs12>
                        <v-card class="user-account-card padding-right-xxl">
                            <v-form ref="userAccountForm" v-model="valid" class="margin-bottom-xl">

                                <div class="errorMsg" v-html="errorMsg"></div>

                                <v-layout row wrap>
                                    <v-flex xs12 sm4>
                                        <h3 class="account-details-section">{{text("api.registration.personaldetails")}}</h3>
                                        <div class="user-registration-input-field">
                                            <div v-if="salutationList && getAccountData.salutation">
                                                <v-radio-group v-model="getAccountData.salutation" :rules="validationRules.salutation" row class="radio-group--required" ref="salutation">

                                                    <v-radio v-for="salutation in salutationList"
                                                             :key="'salutation-'+ salutation.key"
                                                             :label="salutation.name"
                                                             :value="salutation.key"
                                                             color="primary"
                                                             class="salutation"
                                                             @change="onChange"
                                                    ></v-radio>

                                                </v-radio-group>
                                            </div>
                                        </div>

                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                type="text"
                                                name="firstName"
                                                v-model="getAccountData.firstName"
                                                :rules="validationRules.firstName"
                                                tabindex="3"
                                                :label="text('api.registration.firstname')"
                                                class="input-group--required"
                                            ></v-text-field>
                                        </div>

                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                type="text"
                                                name="name"
                                                :label="text('api.registration.lastname')"
                                                v-model="getAccountData.name"
                                                :rules="validationRules.name"
                                                tabindex="4"
                                                class="input-group--required"
                                            ></v-text-field>
                                        </div>

                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                type="text"
                                                name="title"
                                                :label="text('api.registration.usertitle')"
                                                v-model="getAccountData.title"
                                                :rules="validationRules.title"
                                                tabindex="5"
                                            ></v-text-field>
                                        </div>

                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                type="text"
                                                name="username"
                                                :label="text('api.registration.username')"
                                                v-model="getAccountData.username"
                                                :rules="validationRules.username"
                                                tabindex="15"
                                                class="input-group--required"
                                            ></v-text-field>
                                        </div>
                                    </v-flex>


                                    <v-flex xs12 sm4>
                                        <h3 class="account-details-section">{{text("api.registration.contactinfo")}}</h3>

                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                type="text"
                                                name="phone"
                                                :label="text('api.registration.phone')"
                                                v-model="getAccountData.phone"
                                                :rules="validationRules.phone"
                                                tabindex="6"
                                            ></v-text-field>
                                        </div>

                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                type="text"
                                                name="mobile"
                                                :label="text('api.registration.mobile')"
                                                v-model="getAccountData.mobile"
                                                :rules="validationRules.mobile"
                                                tabindex="7"
                                            ></v-text-field>
                                        </div>

                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                type="text"
                                                name="email"
                                                :label="text('api.registration.email')"
                                                v-model="getAccountData.email"
                                                :rules="validationRules.email"
                                                tabindex="13"
                                                class="input-group--required"
                                            ></v-text-field>
                                        </div>

                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                type="text"
                                                name="emailConfirmation"
                                                :label="text('api.registration.email.confirm')"
                                                v-model="emailConfirmation"
                                                :rules="validationRules.emailConfirmation"
                                                tabindex="14"
                                                class="input-group--required"
                                            ></v-text-field>
                                        </div>
                                    </v-flex>



                                    <v-flex xs12 sm4>
                                        <h3 class="account-details-section">{{text('api.registartion.useraddress')}}</h3>
                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                type="text"
                                                name="institution"
                                                :label="text('api.registration.institution')"
                                                v-model="getAccountData.institution"
                                                :rules="validationRules.institution"
                                                tabindex="8"
                                            ></v-text-field>
                                        </div>

                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                type="text"
                                                name="street"
                                                :label="text('api.registration.street')"
                                                v-model="getAccountData.street"
                                                :rules="validationRules.street"
                                                tabindex="9"
                                            ></v-text-field>
                                        </div>

                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                type="text"
                                                name="postCode"
                                                :label="text('api.registration.areacode')"
                                                v-model="getAccountData.postCode"
                                                :rules="validationRules.postCode"
                                                tabindex="10"
                                            ></v-text-field>
                                        </div>

                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                type="text"
                                                name="city"
                                                :label="text('api.registration.city')"
                                                v-model="getAccountData.city"
                                                :rules="validationRules.city"
                                                tabindex="11"
                                            ></v-text-field>
                                        </div>

                                        <div class="user-registration-input-field country-list padding-right-xxl" v-if="countryList">
                                            <v-select
                                                :label="text('api.registration.country')"
                                                :items="getCountryList"
                                                item-text="name"
                                                item-value="id"
                                                v-model="getAccountData.country"
                                                append-icon="keyboard_arrow_down"
                                                tabindex="12"
                                            ></v-select>
                                        </div>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>
                                    <v-flex xs12 sm12>
                                        <div class="padding-right-xxl">
                                            <v-checkbox
                                                :label="text('api.registration.newsletter')"
                                                v-model="getAccountData.hasNewsletter"
                                                color="primary"
                                                tabindex="19"
                                                @change="changeNewsletter"
                                                ref="newsletter"
                                            ></v-checkbox>
                                        </div>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>
                                    <v-flex xs12 sm4>
                                        <div class="padding-right-l">
                                            <v-btn block @click="saveUserAccount" color="primary" class="btn-user-account" :disabled="!valid" tabindex="20">{{text('api.button.update')}}</v-btn>
                                        </div>
                                    </v-flex>
                                </v-layout>

                            </v-form>
                        </v-card>
                    </v-flex>



                    <v-flex lg3 xs12>
                        <v-card class="user-password-card padding-right-xxl">
                            <v-form ref="userPasswordForm" v-model="validPassword" class="margin-bottom-xl">

                                <div class="errorMsg" v-html="errorMsg"></div>

                                <h3 class="account-details-section">{{text('api.registration.changePassword')}}</h3>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                :append-icon="isPasswordVisible ? 'visibility_off' : 'visibility'"
                                                :type="isPasswordVisible ? 'text' : 'password'"
                                                name="oldPassword"
                                                :label="text('api.registration.currentPassword')"
                                                v-model="getAccountData.oldPassword"
                                                :rules="validationRules.password"
                                                :append-icon-cb="togglePasswordValueVisibility"
                                                tabindex="16"
                                                @input="validateUserAccountForm"
                                                class="input-group--required password-input"
                                                :class="{'password-visibility': isPasswordVisible}"
                                            ></v-text-field>
                                        </div>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                :append-icon="isPasswordVisible ? 'visibility_off' : 'visibility'"
                                                :type="isPasswordVisible ? 'text' : 'password'"
                                                name="newPassword"
                                                :label="text('api.registration.password')"
                                                v-model="getAccountData.newPassword"
                                                :rules="validationRules.newPassword"
                                                :append-icon-cb="togglePasswordValueVisibility"
                                                tabindex="17"
                                                @input="validateUserAccountForm"
                                                class="input-group--required password-input"
                                                :class="{'password-visibility': isPasswordVisible}"
                                            ></v-text-field>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12>
                                        <div class="user-registration-input-field padding-right-xxl">
                                            <v-text-field
                                                :append-icon="isPasswordConfirmationVisible ? 'visibility_off' : 'visibility'"
                                                :type="isPasswordConfirmationVisible ? 'text' : 'password'"
                                                name="passwordConfirmation"
                                                :label="text('api.registration.password.again')"
                                                v-model="getAccountData.passwordConfirmation"
                                                :rules="validationRules.passwordConfirmation"
                                                :append-icon-cb="togglePasswordConfirmationValueVisibility"
                                                tabindex="18"
                                                id="passwordConfirmationInputField"
                                                @input="validateUserAccountForm"
                                                class="input-group--required password-input"
                                                :class="{'password-visibility': isPasswordConfirmationVisible}"
                                            ></v-text-field>
                                        </div>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>
                                    <v-flex lg12 md4 class="padding-right-xxl">
                                        <v-btn block @click="saveUserPassword" color="primary" class="btn-user-account" :disabled="!validPassword" tabindex="20">{{text('api.registartion.button.changePassword')}}</v-btn>
                                    </v-flex>
                                </v-layout>

                            </v-form>
                        </v-card>
                    </v-flex>



                </v-layout>
            </div>

        </v-container>

        <v-snackbar v-model="isUserAccountPassFormSubmitted" :color="'success'" :timeout="5000" top multi-line>
            <div v-html="text('db.global.TYPE_GTM_MYDATA_SUCCESS_NOTIFICATION')"></div>
        </v-snackbar>

        <v-snackbar v-model="errorOldPasswordUserAccount" :color="'error'" :timeout="5000" top multi-line >
            <div>{{text("api.registration.error.oldpassword")}}</div>
        </v-snackbar>

        <v-snackbar v-model="mustShowErrorDuplicateEmail" :color="'error'" :timeout="5000" top multi-line >
            <div>{{text("api.error.duplicate.email")}}</div>
        </v-snackbar>
    </div>
</template>



<!-- ################################################################## -->

<script>

import {mapGetters} from 'vuex';
import HeaderBar from "../shared/HeaderBar"
import TopBar from '../../../common/components/shared/TopBar';
import Vue from "vue";

export default {
        name: "UserAccountPage",
        components: {
            HeaderBar,
            TopBar
        },
        data() {
            return {
                errorMsg: null,
                valid: true,
                isPasswordVisible: false,
                isPasswordConfirmationVisible: false,

                isUserAccountPassFormSubmitted: false,

                emailConfirmation: "",
                passwordConfirmation: "",

                mustShowErrorDuplicateEmail: false,

                validationRules: {
                    salutation: [
                        (value) => {
                            let selectedSalutationObj = this.salutationList.filter((crtSalutationObj) => {
                                return (value === crtSalutationObj.key);
                            });
                            return (selectedSalutationObj.length === 1) ? true : this.text("api.error.field.required");
                        }
                    ],
                    firstName: [
                        (value) => (value || "").length > 0 || this.text("api.error.field.required"),
                        (value) => (value || "").length <= 64 || this.text("api.error.field.length.exceeded", [64])
                    ],
                    name: [
                        (value) => (value || "").length > 0 || this.text("api.error.field.required"),
                        (value) => (value || "").length <= 64 || this.text("api.error.field.length.exceeded", [64])
                    ],
                    title: [
                        (value) => (value || "").length <= 64 || this.text("api.error.field.length.exceeded", [64])
                    ],
                    institution: [
                        (value) => (value || "").length <= 128 || this.text("api.error.field.length.exceeded", [128])
                    ],
                    street: [
                        (value) => (value || "").length <= 128 || this.text("api.error.field.length.exceeded", [128])
                    ],
                    postCode: [
                        (value) => (value || "").length <= 32 || this.text("api.error.field.length.exceeded", [32])
                    ],
                    city: [
                        (value) => (value || "").length <= 128 || this.text("api.error.field.length.exceeded", [128])
                    ],
                    phone: [
                        (value) => (value || "").length <= 64 || this.text("api.error.field.length.exceeded", [64])
                    ],
                    mobile: [
                        (value) => (value || "").length <= 64 || this.text("api.error.field.length.exceeded", [64])
                    ],
                    username: [
                        (value) => (value || "").length > 0 || this.text("api.error.field.required"),
                        (value) => (value || "").length >= 6 || this.text("api.error.username.too.short"),
                        (value) => (value || "").length <= 128 || this.text("api.error.field.length.exceeded", [128])
                    ],
                    email: [
                        (value) => (value || "").length > 0 || this.text("api.error.field.required"),
                        (value) => {
                            let regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                            return regex.test(value) || this.text("api.error.email.invalid");
                        }
                    ],
                    emailConfirmation: [
                        (value) => (value || "").length > 0 || this.text("api.error.field.required"),
                        (value) => (this.getAccountData.email && this.getAccountData.email === value) || this.text("api.error.email.match")
                    ],
                    password: [
                        (value) => {
                            let isPassConfirmEntered = (this.getAccountData.oldPassword || "").length > 0;
                            let isPassEntered = (value || "").length > 0;
                            return (isPassConfirmEntered && !isPassEntered ) ? this.text("api.error.field.required") : true;
                        },
                        (value) => (value || "").length <= 72 || this.text("api.error.field.length.exceeded", [72]),
                        (value) =>{
                            return (this.errorOldPasswordUserAccount || this.isUserAccountPassFormSubmitted || (value || "").length > 0) || this.text("api.error.field.required");
                        }
                    ],
                    newPassword: [
                        (value) => {
                            let isPassConfirmEntered = (this.getAccountData.passwordConfirmation || "").length > 0;
                            let isPassEntered = (value || "").length > 0;
                            return (isPassConfirmEntered && !isPassEntered) ? this.text("api.error.field.required") : true;
                        },
                        (value) => (!(value || "").length > 0 || (value || "").length >= 6) || this.text("api.error.password.too.short"),
                        (value) => (value || "").length <= 72 || this.text("api.error.field.length.exceeded", [72]),
                        (value) =>{
                            return (this.errorOldPasswordUserAccount || this.isUserAccountPassFormSubmitted || (value || "").length > 0) || this.text("api.error.field.required");

                        }
                    ],
                    passwordConfirmation: [
                        (value) => {
                            let isPassEntered = (this.getAccountData.newPassword || "").length > 0;
                            let isPassConfirmEntered = (value || "").length > 0;
                            return (isPassEntered && !isPassConfirmEntered) ? this.text("api.error.field.required") : true;
                        },

                        (value) => {
                            let passwordConfirmationVal = (value || "");
                            let passwordVal = (this.getAccountData.newPassword || "");
                            return (passwordConfirmationVal === passwordVal) ? true : this.text("api.error.password.match");
                        },
                        (value) =>{
                            return (this.errorOldPasswordUserAccount || this.isUserAccountPassFormSubmitted || (value || "").length > 0) || this.text("api.error.field.required");
                        }
                    ],
                    legalTerms: [
                        (value) => (typeof value !== "undefined" && value === true) || this.text("api.error.agreement.accept"),
                    ],
                },
                validPassword: false,
                errorOldPasswordUserAccount: false,
                radioButtonPlugin: Vue.RadioButton.RadioButtonSvg,
                checkBoxPlugin: Vue.CheckBox.checkBoxSvg,
                arrowDownPlugin: Vue.ArrowDown.arrowDownSvg

            }
        },

        computed: {
            ...mapGetters({
                getAccountData: 'UserStore/getAccountData',
                getCountryList: 'UserStore/getCountryList',
                getSalutationList: 'UserStore/getSalutationList',
                getUserData: 'UserStore/getUserData',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue'
            }),
            countryList () {
                let countryList = Object.keys(this.getCountryList).map((crtCountryKey, crtIndex) => {
                    return { name: this.getCountryList[crtCountryKey], key: parseInt(crtCountryKey) };
                });
                return countryList;
            },
            salutationList () {
                let salutationList = Object.keys(this.getSalutationList).map((crtSalutationKey, crtIndex) => {
                    return { name: this.getSalutationList[crtSalutationKey], key: parseInt(crtSalutationKey) };
                });
                return salutationList;
            }
        },

        beforeCreate() {
            this.$store.dispatch("UserStore/loadAccountData").then((response) => {
                this.emailConfirmation = this.getAccountData.email;
            });
        },

        created() {
            this.validateUserAccountForm();
        },

        mounted() {
            let selectedInputIcon = document.getElementsByClassName('country-list');
            let selectCountry = selectedInputIcon[0].getElementsByClassName('input-group__append-icon');
            selectCountry[0].innerHTML = this.arrowDownPlugin();
        },

        methods: {

            // --------- Component methods. ---------

            saveUserAccount () {

                if (this.$refs.userAccountForm.validate()) {
                    let paramsToSubmit = {
                        salutation:         this.getAccountData.salutation,
                        firstName:          this.getAccountData.firstName,
                        name:               this.getAccountData.name,
                        title:              this.getAccountData.title,
                        phone:              this.getAccountData.phone,
                        mobile:             this.getAccountData.mobile,
                        institution:        this.getAccountData.institution,
                        street:             this.getAccountData.street,
                        postCode:           this.getAccountData.postCode,
                        city:               this.getAccountData.city,
                        country:            this.getAccountData.country,
                        email:              this.getAccountData.email,
                        username:           this.getAccountData.username,
                        hasNewsletter:      this.getAccountData.hasNewsletter
                    };
                    if ((this.getAccountData.password || "").length > 0) {
                        paramsToSubmit.password = this.getAccountData.password;
                    }

                    this.$store.dispatch("UserStore/submitChangeUserAccount", paramsToSubmit).then((resp) => {
                        this.isUserAccountPassFormSubmitted = true;
                    }).catch((err) => {
                        let serverResponseData = {};
                        if (typeof err.serverResponse !== "undefined" && typeof err.serverResponse.data !== "undefined") {
                            serverResponseData = err.serverResponse.data;
                        }

                        if (typeof serverResponseData.returnCode !== "undefined" && serverResponseData.returnCode === 104) { // 104 means that there is already another user having this email.
                            this.mustShowErrorDuplicateEmail = true;
                        }
                    });
                }
            },

            validateUserAccountForm() {
                if (this.$refs.userAccountForm){
                    this.$refs.userAccountForm.validate();
                }
            },

            togglePasswordValueVisibility() {
                this.isPasswordVisible = !this.isPasswordVisible;
            },
            togglePasswordConfirmationValueVisibility() {
                this.isPasswordConfirmationVisible = !this.isPasswordConfirmationVisible;
            },
            saveUserPassword () {


                if (this.$refs.userAccountForm.validate()) {
                    let paramsToSubmit = {
                        oldPassword: this.getAccountData.oldPassword,
                        newPassword: this.getAccountData.newPassword,

                    };
                    let promiseChangeUserPassword = this.$store.dispatch("UserStore/submitChangeUserPasswordAccount", paramsToSubmit);
                    promiseChangeUserPassword.then((resp) => {
                        this.$store.commit("UserStore/setItemsInAccountData", {
                            password: "",
                            passwordConfirmation: "",
                            newPassword: "",
                            oldPassword: ""
                        });
                        this.isUserAccountPassFormSubmitted = true;
                        this.validPassword = false;

                    });
                    promiseChangeUserPassword.catch(() => {
                        this.$store.commit("UserStore/setItemsInAccountData", {
                            passwordConfirmation: "",
                            newPassword: "",
                            oldPassword: ""
                        });
                        this.errorOldPasswordUserAccount = true;
                        this.validPassword = false;
                    })
                }

            },
            onChange($el) {
                let elem = $el;
                let clickedRadio = document.getElementsByClassName('salutation')[elem-1];
                let that = this;
                setTimeout(function() {
                    let radio = clickedRadio.getElementsByClassName('icon--radio');
                    radio[0].innerHTML = that.radioButtonPlugin();
                }, 100)

            },
            changeNewsletter($el) {
                if ($el){
                    let that = this;
                    setTimeout(function() {
                        let checkNewsletter = document.getElementsByClassName('icon--checkbox');
                        checkNewsletter[0].innerHTML = that.checkBoxPlugin();
                    }, 100)
                }
            }
        },
        beforeMount() {
            if(!this.getUserData.certificate){
                this.$router.push('/user-account');
            } else {
                this.$router.push('/');
            }
        },
        watch: {
            getAccountData(newVal, oldValue) {
                if (newVal) {
                    let that = this;
                    setTimeout(function() {
                        if (that.$refs.salutation) {
                            let radio = that.$refs.salutation.$el.getElementsByClassName('icon--radio');
                            radio[0].innerHTML = that.radioButtonPlugin();
                        }
                        if (that.$refs.newsletter) {
                            let checkNewsletter = that.$refs.newsletter.$el.getElementsByClassName('icon--checkbox');
                            if (checkNewsletter.length > 0) {
                                checkNewsletter[0].innerHTML = that.checkBoxPlugin();
                            }
                        }
                    }, 100);
                }
            }
        }


    }
</script>

<style scoped lang="scss">

    .container.grid-list-xl .layout.page-content.user-account-page-content {
        margin-top: 0 !important;

        & > .flex.align-start {
            padding-bottom: 0;
        }
    }

    .scrolling-content-useraccount {
        position: fixed;
        overflow: auto;
        top: 68px;
        bottom: 0;
        padding-top: 19px;
        margin: 0 !important;
        width: 100%;
    }


    @media only screen and (max-width: 600px) {

        .scrolling-content-useraccount {
            top: 60px;
            position: fixed;
            bottom: 0;
            overflow: auto;
            padding-top: 19px;
            width: 100%;
            overflow-x: hidden;
            margin: 0 !important;
        }


    }

    .container.grid-list-xl .layout.page-content.scrolling-content-useraccount {
        z-index: 0 !important;
    }

    .salutation .input-group {
        padding-top: 0;
        width: 50%;
    }


    @media only screen and (min-width: 1201px) and (max-width: 1699px) {

        .salutation .input-group {
            padding-top: 0;
            width: 100% !important;
        }
    }

    @media only screen and (max-width: 1200px) {
        .salutation .input-group {
            padding-top: 0;
            width: 100% !important;
        }
    }

    .page-title {
        font-weight: $font-weight-page-title;
        font-size: $font-size-page-title;
    }



    .user-account-card, .user-password-card {
        padding: 50px 10px 50px 50px !important;
        background-color: $color-block-background;
        border: 1px solid $color-block-border;


        form {
            border-top: none !important;

        }
    }

    .account-details-section {
        font-weight: $font-weight-bold;
    }


</style>



// WEBPACK FOOTER //
// src/professional/components/user-account/UserAccountPage.vue